module.exports = __webpack_public_path__ + "images/accents/ao-download@1x-9ab6275e4064e6f13f3c3c69bd10a2cc.webp";